import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { CHAT_PATH } from "utils/hooks/useBackgroundLocation";

const GroupInviteRedirect = () => {
  const { code } = useParams();

  return <Navigate replace to={`${CHAT_PATH}/g/${code}`} />;
};

export default GroupInviteRedirect;
